import React from 'react';
import ReactDOM from 'react-dom';

//component
import PasskeySettingsScreen from  '@/components/page/OrgSettings/Passkeys/PasskeySettingsScreen';
import { GrantTypeService } from '@/services/grantType.service';


const PasskeySettingsPortal = () => {    
    const targetContainer = document.getElementById('react-passkey-settings-container');
    const orgId = targetContainer?.dataset.orgId

    // this is a global service, so only set it for portals that exist
    if(targetContainer) {
      //should be mfa 
      
      GrantTypeService.initGrantTypeService({
        isMfa: targetContainer?.dataset.isMfaSession=== 'True',
        isExternalLogin: targetContainer?.dataset.isExternalLogin === 'True'
      })
    }

    if (!targetContainer || !orgId) {
        return null;
    } 

    return ReactDOM.createPortal(
      <PasskeySettingsScreen orgId={orgId}/>, targetContainer
    );
}


export default PasskeySettingsPortal;